import { render, staticRenderFns } from "./Hortensebuisness.vue?vue&type=template&id=38d3ddbe&"
import script from "./Hortensebuisness.vue?vue&type=script&lang=js&"
export * from "./Hortensebuisness.vue?vue&type=script&lang=js&"
import style0 from "./Hortensebuisness.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Fstatic-pages&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports